import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from "../../shared/translate/translate.service";
import { SchedulerBookingModel } from "../models/schedular-booking.model";
import { AuthService } from "../../shared/models/auth.service";
import { Router } from "@angular/router";
import { ApplicationRouteURL, WeGoAuthorizedLink, Permission, PermissionType } from "../../shared/config";

@Component({
  selector: 'booking-info-popup',
  styles: [`
     .table th, .table td { 
        border-top: none !important;
        border-left: none !important;
      }
      #bookingInfobody .col-sm-5 {
        padding-right: 1px;
      }
      #bookingInfobody .col-sm-7 {
        padding-right: 1px;
      }
    `
  ],
  template: ` <div bsModal #bookingInfoModel="bs-modal" class="modal fade" tabindex="-1" role="dialog" 
  aria-labelledby="mySmallModalLabel" aria-hidden="true" [config]="{backdrop: false, keyboard: false}">
    <div class="modal-dialog modal-sm" >
 <div class="modal-content" style="border-radius: 25px;">            
  <div *ngIf="bookingInfo" class="modal-body" id="bookingInfobody">
              <div class="row">
              <div class="col-sm-5"><strong>{{ 'LblBooking' | translate }}</strong></div>
              <div *ngIf="!isDriver" class="col-sm-7">       
                <wego-authorized-link [LinkModel]="bookingInfoLink"></wego-authorized-link>
               </div>
              <div *ngIf="isDriver" class="col-sm-7"> {{ bookingInfo.bookingReferenceID }}</div>
              </div>
              <div class="row">
              <div class="col-sm-5"><strong>{{ 'LblFrom' | translate }}</strong></div>
              <div class="col-sm-7">{{ bookingInfo.startDateTime }}</div>
              </div>
              <div class="row">
              <div class="col-sm-5"><strong>{{ 'LblTo' | translate }}</strong></div>
              <div class="col-sm-7">{{ bookingInfo.endDateTime }}</div>
              </div>
              <div class="row">
              <div class="col-sm-5"><strong>{{ 'LblLicenceTag' | translate }}</strong></div>
              <div class="col-sm-7">{{ bookingInfo.licenceTag }}</div>
              </div>
              <div *ngIf="bookingInfo.driverName" class="row">
              <div class="col-sm-5"><strong>{{ 'LblDriver' | translate }}</strong></div>
              <div class="col-sm-7">{{ bookingInfo.driverName }}</div>
              </div>
              <div *ngIf="bookingInfo.mobile" class="row">
              <div class="col-sm-5"><strong>{{ 'LblMobile' | translate }}</strong></div>
              <div class="col-sm-7">{{ bookingInfo.mobile }}</div>
              </div>
              <div *ngIf="bookingInfo.email" class="row">
              <div class="col-sm-5"><strong>{{ 'LblEmail' | translate }}</strong></div>
              <div class="col-sm-7" style="word-wrap: break-word;">{{ bookingInfo.email }}</div>
        </div>       
       </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-green" (click)="hide($event)">{{ 'LblOK' | translate }}</button>                
            </div>
        </div>
    </div>
  </div>`
})

export class BookingInfoPopupComponent implements OnInit, OnDestroy {
  bookingInfoLink: any;
  urlBookingInformation: string;
  _popupTitle: string = this.translate.instant('LblConfirm');
  _bookingInfo: any;
  isDriver: boolean;

  @ViewChild('bookingInfoModel') public bookingInfoModel: ModalDirective;

  @Input()
  set bookingInfo(bookingInfo: any) {
    this._bookingInfo = bookingInfo;
  }
  get bookingInfo() { return this._bookingInfo; }

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblConfirm');
  }
  get popupTitle() { return this._popupTitle; }

  @Output('onConfirm') onConfirm = new EventEmitter();

  constructor(private translate: TranslateService,
    private authService: AuthService,
    private router: Router, ) { }


  ngOnInit() {
    this.urlBookingInformation = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING_INFORMATION);
    this.isDriver = this.authService.IsDriver();



  }

  public show() {
    this.bookingInfoModel.show();
    this.bookingInfoLink = new WeGoAuthorizedLink(this.urlBookingInformation + "/" + this.bookingInfo.bookingHashId,
      Permission.PR_BOOKINGS_OVERVIEW, PermissionType.VIEW, '', this.bookingInfo.bookingReferenceID, "", "", true, "");

  }

  public hide() {
    this.bookingInfoModel.hide();
  }

  private Confirm($event: any) {
    this.onConfirm.emit($event);
  }

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-info-popup.component.ts